import { GarageInfoDto } from "@1games-ru/region-shared/dist/types/garage/garage";
import { create } from "zustand";
import { Tab } from "@/domains/transportWarehouse/constants/tab";

type State = {
  tabs: Tab[];
  currTab: Tab;
  // transportWarehouseInfo: GarageInfoDto | null;
};

type Action = {
  changeTab: (tab: Tab) => void;
  // setTransportWarehouseInfo: (info: GarageInfoDto | null) => void;
};

export const useTransportWarehouseStore = create<State & Action>((set) => ({
  tabs: [Tab.Info, Tab.Transport],
  currTab: Tab.Info,
  transportWarehouseInfo: null,
  changeTab: (tab: Tab) =>
    set({
      currTab: tab,
    }),
  // setTransportWarehouseInfo: (info) => set({ transportWarehouseInfo: info }),
}));
